import withDraft from '@/utils/draftHelper';
import actions from '@/roles/constants';
import { updateAuditName } from './state';

const updateRoleName = withDraft((draft, { code, result: { name } }) => {
  updateAuditName(draft, 'role', code, name);
});

export default {
  [actions.EDIT_ROLE_SUCCESS]: updateRoleName,
};
